"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _tr_TR = _interopRequireDefault(require("../DatePicker/locale/tr_TR"));
var _tr_TR2 = _interopRequireDefault(require("../Calendar/locale/tr_TR"));
var _tr_TR3 = _interopRequireDefault(require("rc-pagination/lib/locale/tr_TR"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import Pagination from 'rc-pagination/lib/locale/en_US';
// import TimePicker from '../time-picker/locale/tr_TR';
var _default = exports.default = {
  locale: 'tr',
  // Pagination,
  DatePicker: _tr_TR.default,
  Pagination: _objectSpread(_objectSpread({}, _tr_TR3.default), {}, {
    totalText: 'Toplam {total} kayıt'
  }),
  // TimePicker,
  Calendar: _tr_TR2.default,
  Table: {
    filterTitle: 'Menü Filtrele',
    filterConfirm: 'Uygula',
    filterReset: 'Temizle',
    emptyText: 'Veri Yok',
    selectAll: 'Hepsini Seç',
    selectInvert: 'Tersini Seç',
    totalText: 'Toplam {total} kayıt',
    edit: 'Güncelle',
    detail: 'Görüntüle',
    delete: 'Sil',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    sortCancel: 'Sıralamayı iptal etmek için tıklayınız',
    sortAsc: 'Düz sıralama için tıklayınız',
    sortDesc: 'Ters sıralama için tıklayınız',
    undo: 'Geri Al',
    selectionInfo: '{count}/{total} kayıt seçildi.'
  },
  TableHeader: {
    add: 'Ekle',
    refresh: 'Yenile',
    excelExport: "Excel'e Aktar",
    csvExport: "Csv'ye Aktar",
    pdfExport: "Pdf'e Aktar"
  },
  Modal: {
    okText: 'Tamam',
    cancelText: 'İptal',
    justOkText: 'Tamam'
  },
  Popconfirm: {
    okText: 'Tamam',
    cancelText: 'İptal'
  },
  Select: {
    notFoundContent: 'Bulunamadı',
    placeholder: 'Seçiniz',
    copy: 'Kopyala'
  },
  TreeSelect: {
    notFoundContent: 'Sonuç bulunamadı',
    placeholder: 'Seçiniz'
  },
  Spin: {
    loadingText: 'Lütfen Bekleyiniz...'
  },
  Upload: {
    uploading: 'Yükleniyor...',
    removeFile: "Dosyay\u0131 kald\u0131r",
    uploadError: 'Yükleme Hatası',
    previewFile: "Dosyay\u0131 \xD6nizle",
    dragText: 'Dosyaları bu alana sürükleyebilir ya da ',
    dragLinkText: 'dosya seçebilirsiniz.'
  },
  Text: {
    edit: 'Düzenle',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    expand: 'Devamı'
  },
  NumberInput: {
    numericValidationError: 'Sadece rakam girebilirsiniz.'
  }
};